import chocolate from "../../images/circleIcons/elasticity/Chocolate_1.png";
import fidget from "../../images/circleIcons/elasticity/fidget_2.png";

import Bacon_3 from "../../images/circleIcons/elasticity/Bacon_3.png";
import Vanilla_4 from "../../images/circleIcons/elasticity/Vanilla_4.png";
import Lithium_5 from "../../images/circleIcons/elasticity/Lithium_5.png";
import Diapers_6 from "../../images/circleIcons/elasticity/Diapers_6.png";
import Pringles_7 from "../../images/circleIcons/elasticity/Pringles_7.png";
import Golden from "../../images/circleIcons/elasticity/Golden Retr_8.png";
import Antibiotics_9 from "../../images/circleIcons/elasticity/Antibiotics_9.png";
import Sugary from "../../images/circleIcons/elasticity/Sugary Soda_10.png";

const questionAnswers = [
  {
      title: "MARKET FOR CHOCOLATE BARS",
      demand: "steep",
      supply: "normal",
      question:
        "Cocoa suppliers in West Africa report severe droughts, resulting in lower crop yields for cocoa beans.",
      subQuestion: "Shift the supply or the demand curve to show what happens in the market for chocolate bars.",
      icon: chocolate,
      answer: "Supply curve shifts left",
      graphType: "supply curve",
      briefness:
        "The drought will lower the supply of available cacoa beans, a primary ingredient in chocolate bars.",
    step2: {
      question:
        "Consumer surveys estimate that demand for chocolate is inelastic.",
      followUpQuestion: "As a percentage, will the price or quantity of chocolate bars change more?",
      answerText: "Price will change more",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "A supply shift to the left is also a movement along the demand curve. In this case, demand is inelastic. Consumers are attached to their chocolates, and do not want to cut back. In order for consumers to cut back on purchases, the percentage price increase will be greater than the percentage decrease in the quantity of chocolate bars sold.",
      answer: "Price"
    },
  },
  {
    title: "MARKET FOR FIDGET SPINNERS",
    demand: "normal",
    supply: "flat",
    question: "Fidget spinners go viral. Every elementary age kid begs their parents for one.",
    subQuestion: "Shift the supply or the demand curve to show what happens in the market for fidget spinners.",
    icon: fidget,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "There are now more customers willing to pay for fidget spinners at any given price. This is shown graphically as a demand shift to the right.",
    step2: {
      question:
        "The supply of fidget spinners is elastic. Teenagers discover they can easily manufacture fidget spinners to sell on their school's 3D printer, and can easily adjust their manufacturing quantities.",
      answerText: "Quantity will change more",
      followUpQuestion: "As a percentage, will the price or quantity of fidget spinners change more?",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "A shift in demand to the right, induces a movement along the supply curve to the right. Since the supply curve is elastic, the percentage change in the quantity supplied will be larger than the percentage increase in price.",
      answer: "Quantity"
    },
  },
  {
    title: "MARKET FOR BACON",
    demand: "normal",
    supply: "steep",
    question: "Health organizations launch national campaigns urging consumers to switch to lean protein options, such as chicken and turkey, and away from fattier cuts of beef and pork, including bacon.",
    subQuestion: "Shift the supply or the demand curve to show what happens in the market for bacon.",
    icon: Bacon_3,
    answer: "Demand curve shifts left",
    graphType: "supply curve",
    briefness:
      "An information campaign urging consumers to switch to leaner protein options is likely to decrease demand overall for a fattier meat such as bacon. With fewer customers interested in bacon, demand shifts to the left.",
    step2: {
      question:
        "In the short to medium term, the supply of bacon in inelastic.",
      answerText: "Price will change more",
      followUpQuestion: "As a percentage, will the price or quantity of bacon change more?",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "Because supply is inelastic, a demand shift to the left will result in a large price drop relative to the percentage decrease in quantity of bacon supplied.",
      answer: "Price"
    },
  },
  {
    title: "MARKET FOR VANILLA EXTRACT",
    demand: "flat",
    supply: "normal",
    question: "Vanilla farmers in India enter the market as Madagascar vanilla becomes increasingly expensive.",
    subQuestion: "Shift the supply or the demand curve to show what happens in the vanilla extract market.",
    icon: Vanilla_4,
    answer: "Supply curve shifts right",
    graphType: "supply curve",
    briefness:
      "When more producers enter the market, there is more supplied at every price. This is a supply shift to the right.",
    step2: {
      question:
        "Cooking magazines suggest that in baking, imitation vanilla is equally as good if not preferable to pure vanilla extract, making demand for pure vanilla extract elastic.",
      answerText: "Quantity will change more",
      followUpQuestion: "As a percentage, will the price or quantity of vanilla extract change more?",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "Because demand is elastic, the percent increase in the quantity supplied of pure vanilla extract will exceed the percent decrease in price.",
      answer: "Quantity"
    },
  },
  {
    title: "MARKET FOR LITHIUM",
    demand: "normal",
    supply: "steep",
    question: "New EV subsidies prompt an EV boom. Manufacturers boost production of EVs with lithium batteries.",
    subQuestion: "Shift the supply or the demand curve to show what happens in the lithium market.",
    icon: Lithium_5,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "Increased demand for EVs will increase demand for inputs, including lithium.",
    step2: {
      question:
        "In the short-run, lithium supply is inelastic. Increasing production requires identifying new lithium deposits and building new mines, which takes years.",
      answerText: "Price will change more",
      followUpQuestion: "As a percentage, will the price or quantity of lithium change more?",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "Because supply is inelastic, a shift to the right in demand will result in larger percentage increase in the price of lithium compared to the percentage increase in quantity supplied.",
      answer: "Price"
    },
  },
  {
    title: "MARKET FOR INFANT DIAPERS",
    demand: "normal",
    supply: "flat",
    question: "There's a baby-boom happening, and birth rates double.",
    subQuestion: "Shift the supply or the demand curve to show what happens in the market for infant diapers.",
    icon: Diapers_6,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "An increase in the number of infants increases the population of diaper-buying parents. This is represented as a shift to the right of the demand curve.",
    step2: {
      question:
        "In the long-run, supply of infant diapers is elastic.",
      answerText: "Quantity will change more",
      followUpQuestion: "As a percentage, will the price or quantity of infant diapers change more?",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "Because supply is elastic, the percentage increase in quantity supplied by diaper manufacturers will exceed the percentage price increase.",
      answer: "Quantity"
    },
  },
  {
    title: "MARKET FOR PRINGLES",
    demand: "flat",
    supply: "normal",
    question: "Pringles reports increased costs in manufacturing their chip canisters.",
    subQuestion: "Shift the supply or the demand curve to show what happens in the market for Pringles.",
    icon: Pringles_7,
    answer: "Supply curve shifts left",
    graphType: "supply curve",
    briefness:
      "The chip canisters are an input in selling Pringles potato chips. An increase in input costs will result in a supply shift to the left.",
    step2: {
      question:
        "Sales data shows that demand for Pringles is elastic, with customers readily willing to switch to alternative chip brands.",
      answerText: "Quantity will change more",
      followUpQuestion: "As a percentage, will the price or quantity of Pringles chips change more?",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "A shift to the left in the supply curve, is a movement up and to the left along the demand curve. Because demand is elastic, and consumers are willing to switch to alternative brands of chips, a small increase in price will result in a larger percentage decrease in the quantity of Pringles sold.",
      answer: "Quantity"
    },
  },
  {
    title: "MARKET FOR GOLDEN RETRIEVER PUPPIES",
    demand: "normal",
    supply: "steep",
    question: "Studies show that dog ownership improves hapiness and health outcomes for individuals.",
    subQuestion: "Shift the supply or the demand curve to show what happens in the market for golden retriever puppies.",
    icon: Golden,
    answer: "Demand curve shifts right",
    graphType: "supply curve",
    briefness:
      "Studies showing positive benefits of dog ownership are likely to result in more individuals being interested in puppy ownership at any given price. This is shown as a shift to the right in the demand curve.",
    step2: {
      question:
        "Assume that the supply of golden retrievers is inelastic in the short run.",
      answerText: "Price will change more",
      followUpQuestion: "As a percentage, will the price or quantity of golden retriever puppies change more?",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "Because the supply of golden retriever puppies is inelastic in the short run, a shift to the right in the demand curve will result in a higher percentage increase in price compared to the percentage increase in the supply of puppies.",
      answer: "Price"
    },
  },
  {
    title: "MARKET FOR ANTIBIOTICS",
    demand: "normal",
    supply: "flat",
    question: 'The American Academy of Pediatrics advises against giving antibiotics in advance for pink eye, citing concerns about antibiotic resistance. Pediatricians recommend a “wait and see” approach instead.',
    subQuestion: "Shift the supply or the demand curve to show what happens to the demand for antibiotics, including those use to treat pink eye in children.",
    icon: Antibiotics_9,
    answer: "Demand curve shifts left",
    graphType: "supply curve",
    briefness:
      "The AAP's recommendation will shift the demand for antibiotics to the left because the recommendation will lower the number of instances pediatricians are likely to prescribe antibiotics.",
    step2: {
      question:
        "In the long-run, supply for antibiotics is elastic.",
      answerText: "Quantity will change more",
      followUpQuestion: "As a percentage, will the price or quantity of antibiotics change more?",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "Because supply is elastic, the decrease in demand (ie shift to the left), will decrease the percentage quantity of antibiotics sold more than the price.",
      answer: "Quantity"
    },
  },
  {
    title: "MARKET FOR SUGARY SODA",
    demand: "normal",
    supply: "flat",
    question: "Widespread usage of GLP-1 drugs such as Wegovy and Ozempic decreases consumers' appetites and cravings for sugary beverages.",
    subQuestion: "Shift the supply or the demand curve to show what happens in the market for sugary soda.",
    icon: Sugary,
    answer: "Demand curve shifts left",
    graphType: "supply curve",
    briefness:
      "Consumers demand fewer sugary sodas while taking weight loss medications. On a widespread scale, this reduces the number of consumers interested in sugary soda, and is shown on the graph as a shift in demand to the left.",
    step2: {
      question:
        "Assume that the supply of sugary soda is elastic.",
      answerText: "Quantity will change more",
      followUpQuestion: "As a percentage, will the price or quantity of soda change more?",
      options: ["Price", "Quantity", "Change will be equal"],
      explanation: "Supply is elastic, A shift of the demand curve is a movement along the supply curve, which in this case is very responsive to demand. The percentage change in the quantity of soda produced will be much greater than the percentage reduction in price.",
      answer: "Quantity"
    },
  },

  // {
  //   title: "MARKET FOR SILVER",
  //   question: "The price of gold goes up.",
  //   subQuestion: "Consider the market for silver. What happens?",
  //   icon: silver,
  //   answer: "Demand curve shifts right",
  //   graphType: "supply curve",
  //   briefness:
  //     "Gold and silver are substitutes. If the price of gold increases, the quantity demanded will decrease. Demand for silver—a substitute—will increase. The demand curve for silver will shift to the right, resulting in movement along the existing supply curve.",
  // },

  // {
  //   title: "MARKET FOR VASES",
  //   question: "The price of flowers increases.",
  //   subQuestion: "Consider the market for vases. What happens?",
  //   icon: vase,
  //   answer: "Demand curve shifts left",
  //   graphType: "supply curve",
  //   briefness:
  //     "Flowers and vases are complements. As the price of flowers increases, the quantity demanded will decrease. Demand for vases—a complement—will decrease. The demand curve for vases will shift to the left and this will result in movement along the existing supply curve.",
  // },

  // {
  //   title: "MARKET FOR E-CIGARETTES",
  //   question: "State governments enact new tax on e-cigarette producers.",
  //   subQuestion: "Consider the market for e-cigarettes. What happens?",
  //   icon: eCigarettes,
  //   answer: "Supply curve shifts left",
  //   graphType: "supply curve",
  //   briefness:
  //     "Imposing a tax on suppliers of e-cigarettes is equivalent to increasing their production costs. The supply curve will shift to the left and this will result in movement along the existing demand curve.",
  // },

  // {
  //   title: "MARKET FOR CHAPSTICK",
  //   question: "Puppy adoptions surge during pandemic.",
  //   subQuestion: "Consider the market for chapstick. What happens?",
  //   icon: chapstick,
  //   answer: "Nothing happens",
  //   graphType: "supply curve",
  //   briefness:
  //     "This was a trick question. As far as we know, there is no relationship between puppy adoptions and the market for chapstick.",
  // },

  // {
  //   title: "MARKET FOR AVOCADOS",
  //   question:
  //     "New farming technology makes it possible to grow avocados in more places.",
  //   subQuestion: "Consider the market for avocados. What happens?",
  //   icon: avocado,
  //   answer: "Supply curve shifts right",
  //   graphType: "supply curve",
  //   briefness:
  //     "If avocados can be grown in more locations, this increases the number of potential avocado sellers. The supply of avocados will increase, the supply curve will shift to the right, and that will result in movement along the existing demand curve.",
  // },

  // {
  //   title: "MARKET FOR LASER EYE SURGERY",
  //   question:
  //     "New law to allow optometrists to perform basic eye surgery by laser, a service previously performed only by those with more training.",
  //   subQuestion: "Consider the market for laser eye surgery. What happens?",
  //   icon: eyeSurgery,
  //   answer: "Supply curve shifts right",
  //   graphType: "supply curve",
  //   briefness:
  //     "If optometrists are now able to offer basic laser eye surgery, the supply of laser eye surgeries will increase. The supply curve for laser eye surgeries will shift to the right and this will result in movement along the existing demand curve.",
  // },

  // {
  //   title: "MARKET FOR GAMING CONSOLES",
  //   question:
  //     "LEAKED: New, more advanced game console to be launched in 6 months.",
  //   subQuestion: "Consider the market for gaming consoles. What happens?",
  //   icon: gaming,
  //   answer: "Demand curve shifts left",
  //   graphType: "supply curve",
  //   briefness:
  //     "If consumers think a new, superior gaming console will be sold in 6 months, they may hold off purchasing a new gaming console until then. Therefore, the demand for gaming consoles now will decrease and the demand curve will shift to the left. This will result in movement along the existing supply curve.",
  // },

  // {
  //   title: "MARKET FOR SODA",
  //   question: "The price of sugar—an ingredient in soda—reaches new heights.",
  //   subQuestion: "Consider the market for soda. What happens?",
  //   icon: soda,
  //   answer: "Supply curve shifts left",
  //   graphType: "supply curve",
  //   briefness:
  //     "If the price of sugar—an input for soda—increases, then the production costs of soda go up. The supply of soda will decrease and the supply curve will shift to the left. This will result in movement along the existing demand curve.",
  // },
];

export default questionAnswers;
